import React, { useState, useRef, useEffect } from 'react';

const SearchableSelect = ({ 
  options, 
  value, 
  onChange, 
  name,
  placeholder = "Rechercher...",
  required = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Find the selected option label
  const selectedOption = options.find(option => option.value === value);
  
  // Filter options based on search term
  const filteredOptions = options.filter(option => 
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    // Add click outside listener to close dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      // Focus the search input when opening the dropdown
      setTimeout(() => {
        inputRef.current?.focus();
      }, 10);
    }
  };

  const handleOptionSelect = (optionValue) => {
    onChange({ target: { name, value: optionValue } });
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div 
        className="form-control d-flex justify-content-between align-items-center cursor-pointer"
        onClick={handleToggleDropdown}
        style={{ cursor: 'pointer' }}
      >
        <div className="text-truncate">
          {selectedOption ? selectedOption.label : required ? placeholder : "Sélectionner une option"}
        </div>
        <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`}></i>
      </div>
      
      {isOpen && (
        <div className="position-absolute w-100 mt-1 border rounded bg-white shadow-sm z-index-1000" style={{ zIndex: 1000, maxHeight: '300px', overflowY: 'auto' }}>
          <div className="p-2 border-bottom">
            <input
              ref={inputRef}
              type="text"
              className="form-control form-control-sm"
              placeholder={placeholder}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          
          {filteredOptions.length > 0 ? (
            <ul className="list-group list-group-flush m-0">
              {required && (
                <li 
                  className={`list-group-item list-group-item-action p-2 ${!value ? 'active' : ''}`}
                  onClick={() => handleOptionSelect('')}
                >
                  Sélectionner une option
                </li>
              )}
              
              {filteredOptions.map(option => (
                <li 
                  key={option.value} 
                  className={`list-group-item list-group-item-action p-2 ${option.value === value ? 'active' : ''}`}
                  onClick={() => handleOptionSelect(option.value)}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          ) : (
            <div className="p-3 text-center text-muted">
              Aucun résultat
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;